// Odkazy na dokumenty na disku firmy (SharePoint, OneDrive, Google Drive, Dropbox).
// ProfitPilot soubory zakázek nedrží — jen odkaz, práva hlídá disk firmy.

export const SLUZBY = {
  SHAREPOINT: { nazev: "SharePoint", zkratka: "SP", barva: "#0f7b8a", bg: "#e6f4f5" },
  ONEDRIVE: { nazev: "OneDrive", zkratka: "OD", barva: "#1f63c6", bg: "#e9f0fb" },
  GDRIVE: { nazev: "Google Disk", zkratka: "GD", barva: "#1b7a3e", bg: "#e8f5ec" },
  DROPBOX: { nazev: "Dropbox", zkratka: "DB", barva: "#2b52d6", bg: "#ebeffc" },
  ODKAZ: { nazev: "Odkaz", zkratka: "URL", barva: "#5c6169", bg: "#f2f2ef" },
};

/** Stejné rozpoznání jako backend (odkazy.sluzba). */
export function sluzba(url) {
  let host = "";
  try { host = new URL(/^https?:\/\//i.test(url || "") ? url : `https://${url}`).hostname.toLowerCase(); } catch { return "ODKAZ"; }
  if (host.endsWith("-my.sharepoint.com")) return "ONEDRIVE";
  if (host.endsWith("sharepoint.com")) return "SHAREPOINT";
  if (host.endsWith("onedrive.live.com") || host.endsWith("1drv.ms")) return "ONEDRIVE";
  if (host.endsWith("drive.google.com") || host.endsWith("docs.google.com")) return "GDRIVE";
  if (host.endsWith("dropbox.com") || host.endsWith("db.tt")) return "DROPBOX";
  return "ODKAZ";
}

export const infoSluzby = (url) => SLUZBY[sluzba(url)] || SLUZBY.ODKAZ;

/** Jak získat odkaz — krátká nápověda pod polem. */
export const NAPOVEDA_ODKAZU =
  "SharePoint / OneDrive: Sdílet → Kopírovat odkaz → „Lidé ve vaší organizaci“. Google Disk: Sdílet → Kopírovat odkaz.";
